module.exports = __webpack_public_path__ + "static/media/avatar-template.1f7e3f8e.jpg";